import axios from 'axios';
import store from '@/store';
import { campaignActionUrl, campaignStatusUrl } from './url';
function authHeaders() {
    const tokenV3 = store?.state?.auth?.tokenV3 ?? '';
    return tokenV3 ? { Authorization: `Bearer ${tokenV3}` } : {};
}
function brandIdParam() {
    const brandId = store?.getters?.selectedBrand?.id ?? store?.state?.brand?.id;
    return brandId ? { brand_id: brandId } : {};
}
export async function updateCampaign(id, payload) {
    const url = campaignActionUrl(id);
    const res = await axios.put(url, payload || {}, {
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        params: { ...brandIdParam() },
    });
    return res.data ?? {};
}
export async function deleteCampaign(id) {
    const url = campaignActionUrl(id);
    const res = await axios.delete(url, {
        headers: { ...authHeaders() },
        params: { ...brandIdParam() },
    });
    return res.data ?? {};
}
export async function finishCampaign(id) {
    const url = campaignStatusUrl(id);
    const res = await axios.patch(url, { status_id: 6 }, {
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        params: { ...brandIdParam() },
    });
    return res.data ?? {};
}
